<template>
  <div class="our-beliefs-innovative-content" id="plataforma-de-marca-nossas-crencas-inovador-e-desbravar" data-search-anchor>
    <div class="our-beliefs-innovative-overlay-title-image">
      <h1 class="our-beliefs-innovative-image-innovative-title" style="margin-top: 4rem;">
        {{ ourBeliefsInnovativeImageTitle }}
      </h1>
      
      <h1 class="our-beliefs-innovative-image-innovative-title">
        {{ ourBeliefsInnovativeImageTitle2 }}
      </h1>

      <h1 class="our-beliefs-innovative-image-innovative-title">
        {{ ourBeliefsInnovativeImageTitle3 }}
      </h1>

      <p class="our-beliefs-innovative-image-innovative-text" style="margin-top: 2rem;">
        {{ ourBeliefsInnovativeImageTitle4 }}
      </p>
    </div>

    <div
      class="our-beliefs-innovative-banner-image"
      :style="{ backgroundImage: `url(${ourBeliefsInnovativeImageSrc})` }"
    ></div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import OurBeliefsPageMixin from '@/mixins/our-beliefs-page-mixin'
import { OurBeliefsPageStore } from '@/store/brand-plataform-page/our-beliefs-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class OurBeliefsInnovativeSection extends Mixins(OurBeliefsPageMixin) {
  ourBeliefsPageStore: PageStoreContract = getModule(OurBeliefsPageStore, this.$store)

  get ourBeliefsInnovativeImageTitle(): string {
    return this.getElementText(6, 0)
  }

  get ourBeliefsInnovativeImageSrc(): string {
    return this.getElementMedia(6, 0)
  }

  get ourBeliefsInnovativeImageTitle2(): string {
    return this.getElementText(6, 1)
  }

  get ourBeliefsInnovativeImageTitle3(): string {
    return this.getElementText(6, 2)
  }

  get ourBeliefsInnovativeImageTitle4(): string {
    return this.getElementText(6, 3)
  }    

  async getOurBeliefsPageStore(): Promise<void> {
    await this.ourBeliefsPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.ourBeliefsPageStore.isLoading) {
      await this.getOurBeliefsPageStore()
    }
  }
}
</script>

<style lang="scss">
.our-beliefs-innovative-content {
  display: grid;
  grid-template-columns: 47% 53%;
  width: 100%;
  max-width: 1032px;
}

.our-beliefs-innovative-banner-image {
  margin-top: 64px;
  position: relative;
  margin-bottom: 4rem;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  height: 600px;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
}

.our-beliefs-innovative-overlay-title-image {
  max-width: 416px;
  width: 100%;
  height: 465px;
}

.our-beliefs-innovative-image-innovative-title {
  font-size: 40px;
  font-weight: 400;
  letter-spacing: -0.01em;  
  margin: 0;
}

.our-beliefs-innovative-image-innovative-text {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: -0.01em;
  line-height: 32px;  
  width: 416px;
  margin: 0;
}
</style>
